import {useAtomValue} from "jotai/index";
import {ApiAtom} from "../../../common-process/1-metl-connection/MetlConnectionProperties.ts";
import {useSuspenseQuery} from "@tanstack/react-query";

export function useGroupProjectList() {
    const api = useAtomValue(ApiAtom)!

    const {data: projects} = useSuspenseQuery({
        queryKey: ["api", api.id, "projects"],
        queryFn: async () => {
            const groups = await api.groups.list()
            const projects = await Promise.all(groups.map(async groupName => {
                const projectNames = await api.groups.get(groupName).projects.list()
                return {
                    groupName,
                    projectNames
                }
            }))
            return projects
        }
    })
    return projects
}